import React, { useMemo, useCallback } from "react";
import throttle from "lodash/throttle";
import { reportError } from "../../../helpers/error-helper";
import {
  AutoSuggestResult,
  defaultGoogleMapsApiKey,
  GooglePlaceSearch,
  SearchLocation,
} from "dora-shared";
import { store } from "../../../redux-store";

export interface AutoCompleteData {
  autocompleteService: google.maps.places.AutocompleteService;
  placesService: google.maps.places.PlacesService;
}

export const AutoCompleteContext = React.createContext<AutoCompleteData | null>(
  null
);

declare global {
  interface Window {
    env: Record<string, unknown>;
  }
}

interface Callback<T> {
  (err: Error | null, data?: T): void;
}

const useGoogleAutoSuggest = () => {
  const callback = useGoogleAutoSuggestCb();
  return useMemo(
    () => throttle(callback, 300, { leading: false, trailing: true }),
    [callback]
  );
};

const useGoogleAutoSuggestCb = () => {
  const search = useMemo(() => {
    const state = store.getState();
    const { googleMapsApiKey } = state.app.apiKeys;
    // if (!googleMapsApiKey) {
    //   setTimeout(() => {
    //     throw new Error("Google maps api key not in state. Using default");
    //   });
    // }
    const autoSuggest = new GooglePlaceSearch({
      apiKey: googleMapsApiKey || defaultGoogleMapsApiKey,
      // fields: ["address_components", "geometry", "name"],
      onError: (err) => {
        console.error({ err });
        reportError({ err });
      },
      onSuccess: () => {},
    });
    return autoSuggest.search.bind(autoSuggest);
  }, []);
  return useCallback(
    (
      searchTerm: string,
      searchLocation: SearchLocation,
      cb: Callback<AutoSuggestResult>
    ) =>
      search(searchTerm, searchLocation).then(
        (x) => cb(null, x),
        (err) => cb(err)
      ),
    [search]
  );
};

export const usePlacePredictions = (searchOrigin?: {
  lon: number;
  lat: number;
}) => ({
  suggest: useGoogleAutoSuggest(),
});
